import { getHttpFunctionUrl, postJsonWithAuth } from './firebase';

export async function processarAlteracaoPlanoAdministrativo({
  usuario, novoPlano, gerarCobranca = false, diasCarencia = 0,
  isencaoProRata = false, isUpgrade = false,
}, gerenciarUsuario) {
  let financeiro = null;

  // Nunca gravar o plano administrativo antes de confirmar a etapa financeira.
  if (gerarCobranca && novoPlano !== 'gratuito') {
    const nomeFuncao = isUpgrade ? 'modificarAssinaturaAsaas' : 'gerarAssinaturaPlano';
    const payload = isUpgrade
      ? { uidCliente: usuario.id, tipoAlteracao: 'upgrade', novoPlano, isencaoProRata }
      : { uidCliente: usuario.id, plano: novoPlano, diasDegustacao: diasCarencia };

    let resposta;
    try {
      resposta = await postJsonWithAuth(getHttpFunctionUrl(nomeFuncao), payload);
    } catch (error) {
      if (!(error instanceof TypeError)) throw error;
      throw new Error('N\u00e3o foi poss\u00edvel confirmar a altera\u00e7\u00e3o no Asaas. Atualize o painel e confira as faturas antes de tentar novamente.');
    }

    financeiro = await resposta.json().catch(() => null);
    if (!resposta.ok || !financeiro?.sucesso) {
      throw new Error(financeiro?.erro || 'N\u00e3o foi poss\u00edvel confirmar a altera\u00e7\u00e3o no Asaas. Confira as faturas antes de tentar novamente.');
    }
  }

  const dadosUsuario = await gerenciarUsuario({
    action: 'update_plan', userId: usuario.id, plan: novoPlano,
  });
  return { usuarioAtualizado: dadosUsuario.user, financeiro };
}
